import { BreadCrumbKeys, BreadCrumLabels, RootPath } from "../../../../components/breadCrumb/enum"
import { NavigatioStateType } from "../../../../utils/enums/navigatetionState"

const detailListPath = `${BreadCrumbKeys.ROOT}=${RootPath.SCHEDULE}-${BreadCrumLabels.SCHEDULE},${RootPath.SCHEDULE_DETAIL_LIST}-${BreadCrumLabels.SCHEDULE_DETAIL_LIST}-{id},${RootPath.RECURRENCE}-${BreadCrumLabels.RECURRENCE}-{recurence_id}-{search}`
const detailUserScheduleListPath = `${BreadCrumbKeys.ROOT}=${RootPath.USER_SCHEDULE}-${BreadCrumLabels.USER_SCHEDULE},${RootPath.USER_SCHEDULE_DETAIL_LIST}-${BreadCrumLabels.USER_SCHEDULE_DETAIL_LIST}-{id},${RootPath.RECURRENCE_USER}-${BreadCrumLabels.RECURRENCE_USER}-{recurence_id}-{search}`

const transform:Record<string, NavigatioStateType> = {
    'schedule-user': NavigatioStateType.USER_SCHEDULE,
    'calendar': NavigatioStateType.SCHEDULE,
}
const transformScedule:Record<string, NavigatioStateType> = {
    'schedule-user': NavigatioStateType.USER_RECURRENCE,
    'calendar': NavigatioStateType.SCHEDULE_RECURRENCE,
}

const navigateOption = {
    [NavigatioStateType.SCHEDULE]: {
        navigate: detailListPath,
        actionPlan: '/dashboard/calendar/action-plan',
        recurrence:'/dashboard/calendar/recurrence',
        reportFolio: '/dashboard/calendar/report-folio-list'
    },
    [NavigatioStateType.USER_SCHEDULE]: {
        navigate: detailUserScheduleListPath,
        actionPlan: '/dashboard/schedule-user/action-plan',
        recurrence:'/dashboard/schedule-user/recurrence',
        reportFolio: '/dashboard/schedule-user/report-folio-list'
    },
}

export { navigateOption, transform, transformScedule }